import { styled } from 'linaria/react';
import { css } from 'linaria';

export const SuccessRegistrationContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SuccessRegistrationContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const KeycardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: var(--rounding-l);
  box-shadow: var(--box-shadow-l);

  @media (max-width: 390px) {
    width: 100%;
  }
`;

export const KeycardHeader = styled.div<{ pro: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-right-radius: var(--rounding-l);
  border-top-left-radius: var(--rounding-l);
  background-color: ${(props) => (props.pro ? 'var(--brand-secondary)' : 'var(--brand-primary)')};

  --keycard-key-color: ${(props) => (props.pro ? 'var(--brand-primary)' : 'var(--brand-secondary)')};
  --keycard-hole-color: ${(props) => (props.pro ? 'var(--brand-primary)' : 'var(--brand-secondary)')};

  padding: 20px 16px;
`;

export const KeycardFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border-bottom-right-radius: var(--rounding-l);
  border-bottom-left-radius: var(--rounding-l);
  padding: 16px 16px 8px;
`;

export const HowToUseWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CasesList = styled.table`
  list-style: none;
  margin-top: 8px;
`;

export const Case = styled.tr`
  td:first-child {
    vertical-align: initial;
  }

  td:first-child div {
    margin-right: 8px;
  }
`;

export const CaseColumn = styled.td`
  white-space: pre-wrap;

  @media (width <= 715px) {
    white-space: initial;
  }
`;

export const CardWithRules = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 33px 0 53px;

  @media (width <= 715px) {
    flex-direction: column;
    gap: 24px;
  }

  @media (max-width: 440px) {
    padding: 8px 0 53px;
  }
`;

export const ConfirmButtonMargin = css`
  margin-top: 32px;

  @media (width <= 715px) {
    margin-top: 0;
  }
`;
